import { Field, reduxForm } from 'redux-form';
import React, { Component } from 'react';
import { renderAutoCompleteSingleSelect, renderTextField } from '../../components/reduxFields';
import { FlatButton } from 'material-ui';
import { LoginButton, LoginButtonDisabled } from '../../components/buttons';
import { connect } from 'react-redux';
import Loader from '../../img/loader.gif';
import { saveLoginQuestions, checkBusinessName, resetSecurityQuestion, removeErrorMessage} from './actions/SecurityQuestionsActions';
import validate from './validate';
import GlobalVariables, { subDomainUrlRedirection } from '../../actions/utilAction';
import LogoImageViewer from '../../components/logoImageViewer'; 

// import getMac from 'getmac';

class LoginQuestions extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
    };
  }

  componentWillMount() {
    let subdomain = subDomainUrlRedirection();
    if (subdomain) {
      this.props.checkBusinessName(subdomain);
    }
  }
  componentWillReceiveProps(nextProps) {
    // console.log('nextProps', nextProps);
    if (nextProps.errorMessage && this.props.errorMessage !== nextProps.errorMessage) {
      let errorMessage = nextProps.errorMessage;
      this.setState({ errorMessage: errorMessage });
    }
  }
  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  removeErrorMessage = () => {
    this.props.removeErrorMessage();
  }

  onSubmit = (formData) => {
    // console.log('formdata--->', formData);
    // require('getmac').getMac(function(err, macAddress) {
    //   if (err) throw err;
    //   console.log(macAddress);
    // });

    if (this.props.authData && this.props.authData.userName && this.props.authData.password) {
      formData.userName = this.props.authData.userName;
      formData.password = this.props.authData.password;
      formData.QuestionID = formData.Questions;
      formData.Answer = formData.Answer;
      let finalAuthData = {};
      finalAuthData.userName = formData.userName;
      finalAuthData.password = formData.password;
      finalAuthData.QuestionID = formData.QuestionID;
      finalAuthData.Answer = formData.Answer;
      finalAuthData.ipaddress = GlobalVariables.IpAddress;
      finalAuthData.macaddress = 'ec:aa:a0:2d:dc:67';
      // console.log('final authdata', JSON.stringify(finalAuthData));
      this.props.saveLoginQuestions(finalAuthData, this.props.businessNameCheck);
    }

  }

  sendMailToResetSEcurityQuestion = () => {
    const{authData} = this.props
    this.props.resetSecurityQuestion(authData,this.props.businessNameCheck)
  }

  MailConfirmation = (message) => (
    <div className="login-fields text-center">
      <div className="resetmail_msg">
        <i className="material-icons">email</i>

        <p>{message}</p>
        {/* <p>A confimation email sent to your mail with reset password link.Thanks!</p> */}

      </div>
    </div>
  );

  renderForm(props) {
    const {handleSubmit} = props;
    return(
      <div className="login-fields">
        <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>

          {this.props.errorMessage ?
            <div className="alert-danger">{this.props.errorMessage}</div>
            : ''}
          {this.props.security_questions && this.props.security_questions.length ?

            <div className ="row">
              <div className = "col-sm-12 require mt-35">
                <Field
                  name="Questions"
                  label="Select a question"
                  handleNewRequest={this.handleNewRequest}
                  options={this.props.security_questions}
                  onChange={(e) => this.removeErrorMessage(e)}
                  disabled={this.props.securityQuestionAttemptLimit}
                  component={renderAutoCompleteSingleSelect}/>
              </div>
              <div className ="col-sm-12 require">
                <Field
                  name='Answer'
                  type="text"
                  maxLength="30"
                  label='Answer'
                  disabled={this.props.securityQuestionAttemptLimit}
                  component={renderTextField} />
              </div>
            </div>
            : '' }
            {this.props.securityQuestionAttemptLimit && 
              <div className="frgtpwd">
                <FlatButton type="button" style={{color:"blue"}} onClick={this.sendMailToResetSEcurityQuestion}>Reset Security Questions</FlatButton>
              </div>
            }
          {this.props.security_questions && this.props.security_questions.length ?
            <div className="pt20">
              {this.props.authenticating ? <LoginButtonDisabled label="Saving" /> : <LoginButton label="Submit" />}
            </div>
            : ''}
        </form>
      </div>
    )
  }

  render() {
    const {authenticatingToken, loaderBusinessToken, businessNameCheck } = this.props;
    let logoUrl = this.props.organizationLogoBase64 && `data:image/png;base64,${this.props.organizationLogoBase64}`;

    if (loaderBusinessToken) {
      return (
        <div className="loadermain">
          <img src={Loader} alt="" />
        </div>
      );
    }
    if (!businessNameCheck) {
      return (
        <div className="login-fields">
          {/* <h3>Login as Agency <i className="flaticon-building"></i></h3>*/}
          {this.props.businessCheckMessage}
        </div>
      );
    }
    if (authenticatingToken) {
      return (
        <div className="login_bg">
          <div className="loaderwrap">
            <div className="loadermain">
              <img src={Loader} alt="" />
            </div>
          </div>
        </div>);
    }
    return (
      <div className="login_bg_WithGradient">
        <div className="login-wrapper">
          <div className="loginlogo">
            <LogoImageViewer isLoginPage={true} logoUrl={logoUrl} businessName={this.props.businessName} />
          </div>
          { this.props.responseSuccessMessage ?
            this.MailConfirmation(this.props.responseSuccessMessage) :
            this.renderForm(this.props)
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  // console.log('ownProps-->', ownProps);
  return {
    authenticating: state.security_questions.authenticating,
    authenticatingToken: state.login.authenticatingToken,
    errorMessage: state.security_questions.errorMessage,
    security_questions: ownProps && ownProps.location && ownProps.location.state && ownProps.location.state.response && ownProps.location.state.response.data ? ownProps.location.state.response.data : [],
    authData: ownProps && ownProps.location && ownProps.location.state && ownProps.location.state.authData ? ownProps.location.state.authData : {},
    loaderBusinessToken: state.login.loaderBusinessToken,
    businessNameCheck: state.login.businessNameCheck,
    businessName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    organizationLogoBase64: state.login.organizationDetails && state.login.organizationDetails.logoBase64,
    businessCheckMessage: state.login.businessCheckMessage,
    organizationDetails: state.login.organizationDetails,
    securityQuestionAttemptLimit: state.security_questions.response && state.security_questions.response.securityQuestionAttemptLimitExceeded,
    responseSuccessMessage : state.security_questions.successMessage,
    removeErrorMessage : state.security_questions.removeErrorMessage,
  };
}

LoginQuestions = reduxForm({
  form: 'LoginQuestionsForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(LoginQuestions);

export default connect(mapStateToProps, { saveLoginQuestions, checkBusinessName, resetSecurityQuestion, removeErrorMessage })(LoginQuestions);



// WEBPACK FOOTER //
// ./src/modules/SecurityQuestions/login_questions.js